import { stringLookup } from '@/utils/zodHelper';
import { z } from 'zod';

const OriginTranslationSchema = z.object({
  id: z.number().optional(),
  name: z.string().max(200),
  language_code: stringLookup().or(z.string()),
  inlineIndex: z.number().optional(),
});

export const OriginSchema = z.object({
  id: z.number().optional(),
  translations: z.array(OriginTranslationSchema).optional(),
  is_active: z.boolean().optional(),
});

export type OriginSchemaType = z.infer<typeof OriginSchema>;
